<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="show" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/30 backdrop-blur-sm" />

        <!-- Modal -->
        <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md animate-fade-in">
          <div class="px-6 pt-6 pb-2">
            <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>
            <p class="mt-2 text-sm text-gray-500 leading-relaxed">{{ message }}</p>
          </div>

          <div class="flex justify-end gap-3 px-6 py-4">
            <button
              @click="$emit('cancel')"
              :disabled="loading"
              class="btn-secondary"
            >
              {{ cancelText }}
            </button>
            <button
              @click="onConfirm"
              :disabled="loading"
              :class="danger ? 'btn-danger' : 'btn-primary'"
            >
              <svg v-if="loading" class="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83"/>
              </svg>
              {{ loading ? 'Processing...' : confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Confirm' },
    message: { type: String, default: 'Are you sure?' },
    confirmText: { type: String, default: 'Confirm' },
    cancelText: { type: String, default: 'Cancel' },
    danger: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ['confirm', 'cancel'],

  methods: {
    onConfirm() {
      if (!this.loading) this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
